export default {"src":"/_next/static/media/delete.78bea8e3.svg","height":18,"width":18};